import { NotixApi } from "./api";

class NotixProfile {
  get() {
    return NotixApi.get("/profile");
  }
  triggerActualProfileData() {
    return NotixApi.post("/profile/legal-info-state");
  }
}

const notixProfileInstance = new NotixProfile();

export default notixProfileInstance;